// Persists per-user filter/sort state for the Lock Desk Queue view.
// The localStorage key includes the azure_id so each user has their own saved state.

const DEFAULTS = {
  timeFrame: 'all',
  statusFilter: 'active',
  requestTypeFilter: '',
  channelFilter: '',
  assignedFilter: '',
  sortBy: 'arrived_date',
  sortDir: 'desc'
}

function getPrefsKey() {
  const azureId = window?.localStorage?.getItem('azure_id') || 'default'
  return `lockDeskQueue.filters.v2:${azureId}`
}

export function readLockDeskQueuePrefs() {
  try {
    const raw = window?.localStorage?.getItem(getPrefsKey())
    if (!raw) return { ...DEFAULTS }
    const parsed = JSON.parse(raw)
    return { ...DEFAULTS, ...parsed }
  } catch (e) {
    return { ...DEFAULTS }
  }
}

export function writeLockDeskQueuePrefs(prefs) {
  try {
    window?.localStorage?.setItem(getPrefsKey(), JSON.stringify(prefs))
  } catch (e) {}
}
